var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteFriends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.532768 26.8109L5.72205 32.0002L8.14911 29.5732L2.95984 24.3838L0.532768 26.8109Z",
    fill: "#F2EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0456 9.48483C22.2545 9.72181 22.616 9.74449 22.853 9.53551C22.8709 9.51971 22.8879 9.50274 22.9037 9.48483L27.5211 4.86741C27.792 4.66429 27.8468 4.28011 27.6437 4.00934C27.4406 3.73857 27.0564 3.68367 26.7856 3.88679C26.7392 3.92167 26.6979 3.96289 26.6631 4.00934L22.0456 8.62676C21.8119 8.865 21.8119 9.24644 22.0456 9.48483Z",
    fill: "#F2EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2265 6.578C19.2653 6.5981 19.3063 6.61366 19.3487 6.62438H19.553C19.8106 6.62195 20.0392 6.45865 20.1251 6.2158L22.1681 0.740314C22.2385 0.409163 22.027 0.0837217 21.6959 0.0134088C21.4258 -0.0439208 21.1507 0.0863809 21.024 0.331655L18.9809 5.80714C18.8359 6.08784 18.9458 6.43299 19.2265 6.578Z",
    fill: "#F2EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4493 9.72947C31.4386 9.68708 31.423 9.6461 31.4029 9.60723C31.3159 9.30353 30.9991 9.12786 30.6954 9.21492C30.672 9.22164 30.649 9.22985 30.6266 9.23947L25.1102 11.2825C24.8128 11.3893 24.6584 11.7169 24.7651 12.0143C24.7705 12.0294 24.7766 12.0443 24.7834 12.059C24.8692 12.3019 25.0978 12.4651 25.3554 12.4675H25.5597L31.0352 10.4245C31.3415 10.3469 31.5268 10.0358 31.4493 9.72947Z",
    fill: "#F2EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1377 4.66293C12.806 4.34641 12.2843 4.34641 11.9527 4.66293C11.6613 4.98868 11.6613 5.48134 11.9527 5.8071L13.9141 7.7276L3.73944 23.4185L9.13319 28.8123L10.972 27.5865L14.6904 31.3049C14.8413 31.4589 15.0469 31.547 15.2625 31.5501C15.474 31.5299 15.674 31.4442 15.8345 31.3049L22.1272 25.0122C22.2812 24.8613 22.3693 24.6557 22.3724 24.4401C22.3806 24.2104 22.2915 23.988 22.1272 23.8272L20.0433 21.7432L24.8241 18.6377L26.7446 20.5991C26.8954 20.7531 27.1011 20.8412 27.3166 20.8443C27.5463 20.8525 27.7687 20.7635 27.9296 20.5991C28.2099 20.2539 28.2099 19.7594 27.9296 19.4141L13.1377 4.66293ZM20.3703 24.4401L15.2625 29.5478L12.4022 26.6875L18.6132 22.6422L20.3703 24.4401Z",
    fill: "#F2EED5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriends);
export default __webpack_public_path__ + "static/media/invite-friends.9ee4710b5d45820cce80b718f8f09dcb.svg";
export { ForwardRef as ReactComponent };